import { Schema } from 'prosemirror-model';

import { imagePlaceholderPlugin } from './image-placeholder.plugin';
import { linkifyPastePlugin } from './linkify-paste.plugin';

export function plugins(schema: Schema) {
  return [linkifyPastePlugin(schema), imagePlaceholderPlugin()];
}
